<div id="app-error-wrapper" class="d-flex justify-content-center align-items-end">
  <div class="error-content d-flex flex-column align-items-center justify-content-start">
    <div class="error-msg">{{msg}}</div>
    <div class="error-btn">
      <button (click)="reload()" class="btn btn-medium secondary">REFRESH</button>
    </div>
  </div>
</div>
